import type { MerryMarkdownProjection } from "./markdownSchema";

const projections = new WeakMap<Element, MerryMarkdownProjection>();

export function registerMerryMarkdownProjection(
  element: Element,
  projection: MerryMarkdownProjection,
) {
  projections.set(element, projection);
}

export function getMerryMarkdownProjection(element: Element) {
  return projections.get(element) ?? null;
}
